import backend from "../utils/backend";
import { GET_SEARCH_RESULTS, GET_SEARCH_RESULTS_SUCCESS, GET_SEARCH_RESULTS_UPDATE, GET_SEARCH_RESULTS_ERROR } from "../constants/actionTypes";

export var getSearchResults = function getSearchResults(search) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var appendResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return function (dispatch) {
    if (!appendResults) {
      dispatch({
        type: GET_SEARCH_RESULTS
      });
    }

    return backend.request({
      method: "GET",
      url: "/search/",
      params: {
        search: search,
        page: page
      }
    }).then(function (response) {
      return dispatch({
        type: appendResults ? GET_SEARCH_RESULTS_UPDATE : GET_SEARCH_RESULTS_SUCCESS,
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: GET_SEARCH_RESULTS_ERROR,
        payload: err
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/actions/search.js